import { Box } from '@mui/material'
import { FC } from 'react'

interface C1DotProps {
    color?: 'warning' | 'success' | 'error'
}

export const C1Dot: FC<C1DotProps> = ({ color = 'warning' }) => <Box sx={{
    backgroundColor: `${color}.main`,
    height: '8px',
    width: '8px',
    borderRadius: '50%',
    display: 'inline-block',
}}
/>
